import React from 'react';
import { makeStyles, Card, Grid, Typography } from '@material-ui/core';
import SVG from 'react-inlinesvg';

import { toAbsoluteUrl } from '../../../../_metronic/_helpers';

export function Tab({ title, score, icon, active, onClick }) {
	const classes = useStyles();

	return (
		<Card className={classes.tab} style={{ paddingBottom: active ? 24 : 20 }} onClick={onClick}>
			<Grid container wrap='nowrap' alignItems='center'>
				<span className={`symbol symbol-circle symbol-50 symbol-${active ? 'dark' : 'light'} mr-2`}>
					<span className='symbol-label'>
						<span
							className={`svg-icon svg-icon-${active ? 'xl' : 'lg'} svg-icon-${
								active ? 'light' : 'dark'
							}`}
						>
							<SVG src={toAbsoluteUrl(icon)}></SVG>
						</span>
					</span>
				</span>

				<Grid container direction='column' style={{ marginLeft: 4 }}>
					<span className={classes.title + ' ' + (active ? classes.active : '')}>{title}</span>
					<Grid container alignItems='center'>
						<Typography className={classes.score + ' ' + (active ? classes.active : '')}>
							{score}
						</Typography>
					</Grid>
				</Grid>
			</Grid>
		</Card>
	);
}

const useStyles = makeStyles(() => ({
	tab: {
		boxShadow: 'none !important',
		padding: '20px 12px',
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10,
		borderBottomRightRadius: 0,
		borderBottomLeftRadius: 0,
		width: '19%',
		cursor: 'pointer',
	},
	title: {
		fontSize: 16,
		color: '#908BA4',
		lineHeight: '16px',
	},
	active: {
		color: 'black !important',
	},
	score: {
		fontSize: 18,
		color: '#353146',
		marginRight: 10,
	},
}));
